import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import { IAdmin } from "src/Types/module/admin/adminTypes";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import AdminTableRow from "./AdminTableRow";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";

const AdminList = () => {
	const [status, setStatus] = useState<string>("active");

	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});

	const { data: admins, isLoading } = useGetQueryWithTotal<IAdmin[]>({
		endPoint: `/api/admin/get/all/status/${status}`,
		queryKeys: ["Admins", status],
		params: {
			...pagination,
		},
	});

	const statusOptions = [
		{
			id: "active",
			name: "Active",
		},
		{
			id: "pending",
			name: "Pending",
		},
		{
			id: "rejected",
			name: "Rejected",
		},
	];

	return (
		<CommCard
			showCardHeader
			headerTitle='Admin List'
			helmetTitle='BTTF - Admin list'
			// handleDateRange={(date) => {
			// 	setDateRange(date);
			// }}
			showStatus
			// statusLabel='Admin List'
			statusOptions={statusOptions}
			handleSelectStatus={(e) => {
				setStatus(e);
			}}
		>
			<TableContainer>
				<Table sx={{ position: "relative", minHeight: "250px" }}>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Name</TableCell>
							<TableCell>Email</TableCell>
							<TableCell>Phone</TableCell>
							<TableCell>Role</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>Action</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : admins?.data?.length ? (
						<TableBody>
							{admins?.data?.map((admin, idx) => (
								<AdminTableRow
									key={admin.user_admin_id}
									admin={admin}
									serial={idx + 1}
								/>
							))}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
			</TableContainer>
			<Box p={2}>
				<CommonPagination
					total={admins?.total}
					paginationCalFun={(limit: number, skip: number) => {
						setPagination({ limit, skip });
					}}
				/>
			</Box>
		</CommCard>
		// <Card>
		// 	<CardHeader
		// 		action={
		// 			<Box width={150}>
		// 				<FormControl fullWidth variant="outlined">
		// 					<InputLabel>Status</InputLabel>
		// 					<Select
		// 						value={status}
		// 						onChange={(e) => setStatus(e.target.value)}
		// 						label="Status"
		// 						autoWidth
		// 					>
		// 						{statusOptions.map((statusOption) => (
		// 							<MenuItem
		// 								key={statusOption.id}
		// 								value={statusOption.id}
		// 							>
		// 								{statusOption.name}
		// 							</MenuItem>
		// 						))}
		// 					</Select>
		// 				</FormControl>
		// 			</Box>
		// 		}
		// 		title="All Admin"
		// 	/>

		// 	<Divider />

		// 	<Box p={2}>
		// 		<TablePagination
		// 			component="div"
		// 			count={admins.length}
		// 			onPageChange={handlePageChange}
		// 			onRowsPerPageChange={handleLimitChange}
		// 			page={page}
		// 			rowsPerPage={limit}
		// 			rowsPerPageOptions={[25, 50, 75, 100]}
		// 		/>
		// 	</Box>
		// </Card>
	);
};

export default AdminList;
